export default class View {
  constructor() {
    this.state = {
      components: {},
      mounted: [],
    };
  }

  setState(newState) {
    this.state = { ...this.state, ...newState };
    return this.state;
  }

  registerComponents(componentsToAdd = {}) {
    this.setState({
      components: {
        ...componentsToAdd,
      },
    });
  }

  deregisterComponents(componentsToRemove = []) {
    const { components } = this.state;
    componentsToRemove.forEach((component) => {
      delete components[component];
    });
  }

  mountComponents() {
    const { state } = this;
    const components = [...document.querySelectorAll('[data-component]')];
    components.forEach((element, componentIndex) => {
      const componentClass = element.getAttribute('data-component');
      const componentMounted = element.getAttribute('data-mounted') || false;
      if (
        !componentMounted
        && state.components[componentClass]
        && typeof state.components[componentClass] === 'function'
      ) {
        this.setState({
          mounted: [
            ...state.mounted,
            {
              id: `${componentIndex}`,
              element,
              mounted: true,
              instance: new state.components[componentClass](element),
            },
          ],
        });
        element.setAttribute('data-mounted', true);
      }
    });
  }

  unmountComponents() {
    const { state } = this;
    state.mounted.forEach((component) => {
      const shouldUnmount = this.componentShouldUnmount(component.element);
      if (
        shouldUnmount
        && component.instance
        && component.mounted === true
        && typeof component.instance.unmount === 'function'
      ) {
        component.instance.unmount();
        component.mounted = false;
      }
    });
  }

  static componentShouldUnmount(element) {
    return !document.documentElement.contains(element);
  }

  /**
   * Mounts each the components passed as arguments
   *
   * @example
   * #templates/product.js
   *
   * import View from 'app/View';
   * import ProductGallery from '../components/product/product-gallery';
   *
   * const productView = new View();
   *
   * productView.init({
   *  ProductGallery,
   * });
   *
   * @param {Object} [config] An input object contaning components
   */
  init(componentsToSet) {
    this.registerComponents(componentsToSet);

    document.addEventListener('DOMContentLoaded', () => {
      this.mountComponents();
      this.bindToWindow();
    });
  }

  bindToWindow() {
    window.theme = window.theme || {};

    window.theme.views = window.theme.views || [];
    window.theme.views.push(this);
  }
}
